import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { pages, WaiverSteps } from 'src/app/alv-enums';
import { BaseComponent } from '../base-components/base-component';
import { DataService } from 'src/app/services/data.service';
import { StoreService } from 'src/app/services/store.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToolsService } from 'src/app/services/tools.service';
import { WaiverService } from 'src/app/services/waiver.service';

@Component({
  selector: 'waiver',
  templateUrl: './waiver.component.html',
  styleUrls: ['./waiver.component.scss']
})
export class WaiverComponent implements OnInit {
  @Input() public currentPage: pages;
  @Input() public registerId: number;
  @Output() private pageChange = new EventEmitter<pages>();
  /** This is here to allow the html code to access the pages enum. */
  public pagesEnum: any;
  /** This is here to allow the html code to access the WaiverSteps enum. */
  public WaiverStepsEnum: any;

  
  constructor(public waiverService: WaiverService, private storeService: StoreService, private toolsService: ToolsService
  ) {
    this.pagesEnum = pages;
    this.currentPage = pages.Order;
    this.WaiverStepsEnum = WaiverSteps;
  }

  goToPaymentPage() {
    const self = this;
    
    self.pageChange.emit(pages.Pay);
  }

  ngOnInit() {
  }
}
